<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Schedules />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";

import Schedules from "../../components/GestionEmpleados/Views/Employee/Schedules.vue";
export default {
  components: { LandingToolbar, Schedules },
};
</script>
